import React from 'react';
import {
  Box,
} from '@mui/material';

const ActionFooter = (props: any) => {
  const { children } = props;

  return (
    <Box className="action-footer">
      {children}
    </Box>
  );
}

export default ActionFooter;
